import { CustomerRepository } from './customer-repository';
import { Customer, UpdateCustomerRequest } from '@/models/customer';

/**
 * Service pour gérer les customers
 * Gère la logique métier autour des customers
 */
export class CustomerService {
  /**
   * Trouve ou crée un customer
   * - Si utilisateur connecté (firebaseUid fourni) : cherche/crée avec firebaseUid
   * - Si utilisateur non connecté : cherche/crée seulement par email (sans Firebase Auth)
   */
  static async findOrCreateCustomer(
    email: string,
    firebaseUid?: string
  ): Promise<Customer> {
    try {
      const normalizedEmail = CustomerRepository.normalizeEmail(email);
      console.log(`🔍 findOrCreateCustomer pour ${normalizedEmail}${firebaseUid ? ` (UID: ${firebaseUid})` : ' (guest)'}`);

      const customer = await CustomerRepository.findOrCreateByEmail(normalizedEmail, firebaseUid);
      console.log(`✅ Customer trouvé/créé: ${customer.id}`);
      return customer;

    } catch (error) {
      console.error(`❌ Erreur dans findOrCreateCustomer pour ${email}:`, error);
      throw error;
    }
  }

  /**
   * Met à jour les informations personnelles d'un customer
   */
  static async updatePersonalInfo(
    customerId: string,
    personalInfo: UpdateCustomerRequest
  ): Promise<Customer> {
    try {
      console.log(`🔍 Mise à jour des informations personnelles pour customer: ${customerId}`);

      const customer = await CustomerRepository.update(customerId, personalInfo);
      console.log(`✅ Informations personnelles mises à jour pour: ${customer.id}`);
      return customer;

    } catch (error) {
      console.error(`❌ Erreur lors de la mise à jour des informations personnelles pour ${customerId}:`, error);
      throw error;
    }
  }
}


